module.exports = __webpack_public_path__ + "static/media/comment3_4.9cec3076.png";